export enum LoggerEventNames {
    SUPPORT_REQUEST_ERROR = 'SUPPORT_REQUEST_ERROR',
    INSTALL_PROMPT_ERROR = 'INSTALL_PROMPT_ERROR',
    LOGIN_ERROR = 'LOGIN_ERROR',
    LOGIN_FAILED = 'LOGIN_FAILED',
    LOGIN_LANDED = 'LOGIN_LANDED',
    // The page a player actually ends up on when the flow breaks. Without it the
    // last thing we know about a failed journey is that it landed.
    FAILED_PAGE_DISPLAYED = 'FAILED_PAGE_DISPLAYED',
    // A landing that stops without logging in and without reaching /failed, so
    // it leaves no other trace at all.
    LOGIN_DEAD_END = 'LOGIN_DEAD_END',
    /**
     * A landing that arrived with a login credential, recorded from the request
     * itself before any of our client code has had a chance to run.
     *
     * The store has had no server-side record of an arrival at all, so a player
     * who left before the bundle executed was indistinguishable from one who
     * never arrived — which is the exact question publishers keep asking. This
     * is the only record that cannot be outrun by the document dying.
     */
    LANDING_RECEIVED = 'STORE_LANDING_RECEIVED',
    /**
     * What the document itself reported while waiting for that bundle: still
     * loading, backgrounded, frozen, gone, or finally running.
     */
    LANDING_BEACON = 'STORE_LANDING_BEACON',
    LOGIN_ATTEMPTED = 'LOGIN_ATTEMPTED',
    LOGIN_COMPLETED = 'LOGIN_COMPLETED',
    SHOP_LANDED = 'SHOP_LANDED',
    BOOT_ERROR = 'BOOT_ERROR',
    LANGUAGE_ERROR = 'LANGUAGE_ERROR',
    ANALYTICS_ERROR = 'ANALYTICS_ERROR',
    STORAGE_ERROR = 'STORAGE_ERROR',
    DOMAIN_ERROR = 'DOMAIN_ERROR',
    PUBLISHER_WEBHOOK_ERROR = 'PUBLISHER_WEBHOOK_ERROR',
    LOGOUT_ERROR = 'LOGOUT_ERROR',
}